/* ============================================================
   ILUMEISTER — Live Google reviews loader
   Shared by sections/google-reviews.liquid and the floating
   reviews widget in layout/theme.liquid. Data comes from the
   ilumeister-reviews Cloudflare Worker (window.ILM_REVIEWS_URL).
   ============================================================ */
(function () {
  var CACHE_KEY = 'ilm_reviews_v5';
  var CACHE_TTL = 5 * 60 * 1000; /* browser copy; the Worker decides how often Google is asked */
  var pending = null;

  /* Numbers + text can't go through lang-engine's exact-match map, so these live here */
  var STRINGS = {
    et: { count: "arvustust Google'is", reviews: 'Google arvustused' },
    en: { count: 'reviews on Google', reviews: 'Google reviews' },
    fi: { count: 'arvostelua Googlessa', reviews: 'Google-arvostelut' }
  };

  function lang() {
    try {
      var l = localStorage.getItem('ilm_lang');
      return l === 'en' || l === 'fi' ? l : 'et';
    } catch (e) { return 'et'; }
  }

  function readCache() {
    try { return JSON.parse(localStorage.getItem(CACHE_KEY) || 'null'); } catch (e) { return null; }
  }

  function writeCache(data) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data: data })); } catch (e) {}
  }

  /* Resolves { data, source } where source is 'live' | 'cached' | 'stale'; rejects if nothing is available.
     force skips the browser copy only — the Worker still decides when Google is called. */
  function get(force) {
    var cached = readCache();
    if (!force && cached && Date.now() - cached.ts < CACHE_TTL) {
      return Promise.resolve({ data: cached.data, source: 'cached' });
    }
    var url = window.ILM_REVIEWS_URL;
    if (!url) {
      return cached ? Promise.resolve({ data: cached.data, source: 'stale' }) : Promise.reject(new Error('no_worker_url'));
    }
    if (pending) return pending;

    pending = fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data || !data.reviews) throw new Error('bad_response');
        writeCache(data);
        pending = null;
        return { data: data, source: 'live' };
      })
      .catch(function (err) {
        pending = null;
        if (cached) return { data: cached.data, source: 'stale' };
        throw err;
      });
    return pending;
  }

  /* "2 months ago" in the visitor's language, from the review's publish date */
  var UNITS = [['year', 31536000], ['month', 2592000], ['week', 604800], ['day', 86400], ['hour', 3600], ['minute', 60]];
  function time(review) {
    var ts = review.published && Date.parse(review.published);
    if (!ts || !window.Intl || !Intl.RelativeTimeFormat) return review.time || '';
    var secs = (ts - Date.now()) / 1000;
    var fmt = new Intl.RelativeTimeFormat(lang(), { numeric: 'auto' });
    for (var i = 0; i < UNITS.length; i++) {
      if (Math.abs(secs) >= UNITS[i][1]) return fmt.format(Math.round(secs / UNITS[i][1]), UNITS[i][0]);
    }
    return fmt.format(0, 'minute');
  }

  /* The first reviews a visitor sees should have text: the newest LEAD_WITH_TEXT reviews
     with text go first, everything else follows newest first (star-only ones included) */
  var LEAD_WITH_TEXT = 3;
  function arrange(reviews) {
    var lead = [], rest = [];
    reviews.forEach(function (r) {
      (lead.length < LEAD_WITH_TEXT && r.text ? lead : rest).push(r);
    });
    return lead.concat(rest);
  }

  function stars(rating) {
    var n = Math.max(0, Math.min(5, Math.round(rating || 0)));
    return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
  }

  function t(key) {
    return (STRINGS[lang()] || STRINGS.et)[key];
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  window.IlmReviews = { get: get, arrange: arrange, stars: stars, time: time, t: t, esc: esc, lang: lang };
})();
